import { defineStore } from 'pinia';
import { StoreModuleName } from '../../constants';

export const useEnvironmentStore = defineStore(StoreModuleName.ENVIRONMENT, () => {
  const isMobile = ref(false);

  const setIsMobile = (val: boolean) => {
    isMobile.value = val;
  };

  return {
    isMobile,
    setIsMobile,
  };
});
